import { gql } from "@apollo/client";
import { client } from "..";

const UserCoupon = gql`
mutation update_user_coupons($clicks: Int = 10, $link_clicks: Int = 10, $downloads: Int = 10, $id: bigint = "") {
  update_user_coupons(where: {id: {_eq: $id}}, _inc: {clicks: $clicks, link_clicks: $link_clicks, downloads: $downloads}) {
    affected_rows
    returning {
      id
      clicks
      link_clicks
      downloads
    }
  }
}
`;

export const UpdateUserCoupon = async (
    id,
    data
  ) => {
    try {
      // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
      // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id
  
      const resp=  await client.mutate({
        mutation: UserCoupon,
       // refetchQueries: [getQuery],
        variables: {
            "id": id,
            "clicks": data.clicks,
            "link_clicks": data.link_clicks,
            "downloads": data.downloads,
          },
          context: {
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NjAwNzgzNzQsImh0dHBzOi8vaGFzdXJhLmlvL2p3dC9jbGFpbXMiOnsieC1oYXN1cmEtYWxsb3dlZC1yb2xlcyI6WyJ1cGRhdGVfdXNlcl9jb3Vwb24iXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoidXBkYXRlX3VzZXJfY291cG9uIn19.JYPDfmgUfBocOJZVdtqPusnbsEcQlvpnQsh1P7newWY",
            },
          },
      });
      if(resp.errors){
        return {success:false}
      }
      // window.location.reload();
    } catch (e) {
      console.log(JSON.stringify(e));
      // showFailureAlert('Something went wrong while updating your cart');
    }
    return {success:true}
  };
export default UpdateUserCoupon;